/* eslint-disable camelcase */

import { fetchList as courseItemFetchList } from '@/api/courseItem'
import { fetchList as courseItemCategoryFetchList } from '@/api/courseItemCategory'
import { fetchList as courseItemMachineFetchList } from '@/api/courseItemMachine'
import { fetchList as unitFetchList } from '@/api/trainingSetUnit'

import { setMenu } from '@/utils/auth'

const state = {
  courseItemList: [],
  courseItemCategoryList: [],
  courseItemMachineList: [],
  unitList: [],
}

const mutations = {
  SET_COURSEITEMLIST: (state, list) => {
    state.courseItemList = list
  },
  SET_COURSEITEMCATEGORYLIST: (state, list) => {
    state.courseItemCategoryList = list
  },
  SET_COURSEITEMMACHINELIST: (state, list) => {
    state.courseItemMachineList = list
  },

  SET_UNITLIST: (state, list) => {
    state.unitList = list
  },
}

const actions = {

  courseItemList({ commit }, parameter) {
    console.log('inside sizeList', { parameter })

    return new Promise((resolve, reject) => {
      courseItemFetchList(parameter).then(Response => {
        commit('SET_COURSEITEMLIST', Response.data.items)
        resolve(Response.data)
      }).catch(err => {

        // console.log('lockerSizeResponse err', err)
      })

      // setMenu(menus)
      // commit('SET_MENUS', menus)
      // resolve(menus)
    }).catch(error => {
      console.log('error', error)
      reject(error)

      // alert('Login failed. Please contact JobTotal Administrator.')
    })
  },

  courseItemCategoryList({ commit }, parameter) {
    // console.log('store list parameter',{parameter})
    return new Promise((resolve, reject) => {
      courseItemCategoryFetchList(parameter).then(Response => {
        // console.log('lockerStatusResponse', Response)
        //  setMenu(menus)
        // commit('SET_MENUS', menus)
        commit('SET_COURSEITEMCATEGORYLIST', Response.data.items)
        resolve(Response.data)
      })
    }).catch(error => {
      console.log('error', error)
      reject(error)

      // alert('Login failed. Please contact JobTotal Administrator.')
    })
  },

  courseItemMachineList({ commit }, parameter) {
    console.log('center list parameter', { parameter })

    return new Promise((resolve, reject) => {
      courseItemMachineFetchList(parameter).then(Response => {
        console.log('lockerStatusResponse', Response)

        //  setMenu(menus)
        // commit('SET_MENUS', menus)
        commit('SET_COURSEITEMMACHINELIST', Response.data.items)
        resolve(Response.data)
      })
    }).catch(error => {
      console.log('error', error)
      reject(error)

      // alert('Login failed. Please contact JobTotal Administrator.')
    })
  },

  unitList({ commit }, parameter) {
    // console.log('center list parameter',{parameter})
    return new Promise((resolve, reject) => {
      unitFetchList(parameter).then(Response => {
        // console.log('lockerStatusResponse', Response)
        //  setMenu(menus)
        // commit('SET_MENUS', menus)
        commit('SET_UNITLIST', Response.data.items)
        resolve(Response.data)
      })
    }).catch(error => {
      console.log('error', error)
      reject(error)

      // alert('Login failed. Please contact JobTotal Administrator.')
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
